import Admin__CategoriesController from './categories.js'

Skylark.App.Controllers.register({
  Admin__CategoriesController
})
